module.exports = __webpack_public_path__ + "img/image.d78391a9.png";